import { CartItem, CheckoutItemPayload } from '../storage/cart.types'

export const productToCheckoutItem = (product: CartItem): CheckoutItemPayload => {
  return {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    lineId: product.lineId!,
    productId: product.productId,
    quantity: product.quantity,
    editedPriceExcGst: product.editedPriceExcGst,
  }
}
